export const API_ROUTES = {
  // Auth
  LOGIN: '/Auth/login',
  REGISTER: '/Auth/register',
  VERIFY_EMAIL: '/Auth/verify-email',
  RESEND_VERIFICATION: '/Auth/resend-verification',
  SOCIAL_LOGIN: '/Auth/socialmedia-login',
  FORGOT_PASSWORD: '/Auth/forgot-password',
  RESET_PASSWORD: '/Auth/reset-password',
  SET_PASSWORD: '/Auth/set-password',
  ACCEPT_INVITATION: '/Auth/accept-invitation',
  VERIFY_TOKEN: '/Auth/verify-token',

  // User onboarding
  CREATE_FAMILY_SPACE_AND_MEMBER: '/User/CreateFamilySpaceAndmember',
  VALIDATE_FAMILY_MEMBER_EMAIL: '/User/validate-familymember',
  SKIP_FAMILY_SPACE: '/User/skip-add-family-space',

  // Profile
  GET_PROFILE: '/Client/GetProfileById',
  UPDATE_PROFILE: '/Client/UpdateProfile',
  UPDATE_PASSWORD: '/Client/ChangePassword',
  UPDATE_PROFILE_PICTURE: '/Client/UpdateProfileImage',

  // Dashboard
  GET_DASHBOARD_STATS: '/Client/GetDashboardStats',
  GET_RECENT_ACTIVITY: '/Client/GetRecentActivity',
} as const;
